import React from 'react'

const staticIntroduction = (props) => {
  const { heading, metaData = [] } = props;
  // const { heading, discription1, discription2, metaData = [] } = props;
  return (
    <>
    <div className='row'>
        <div className='commanSmallFontHeading col-12 text-left'>{heading}</div>
        <div className='col-12 text-left'>
          <ul>
            {metaData.length > 0 && metaData.map((item, index) => (
              <li key={`${index}-key`}>                
                <div className='py-2'>{item}</div>
              </li>
            ))}
            {/* {discription1 && <div className='py-2'>{discription1}</div>}
            {discription2 && <div className='py-2'>{discription2}</div>} */}
          </ul>
        </div>
    </div>
    </>
  )
}

export default staticIntroduction